module.exports = __webpack_public_path__ + "img/Cheer Megaphone60.f7fb1f0d.jpg";